export default __webpack_public_path__ + "static/media/poster2.24aa8b6c.png";